import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Expertise from "./components/Expertise";
import Approach from "./components/Approach";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

export default function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-navy-900 antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Expertise />
        <Approach />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
